import { useContext, useMemo } from "react"

import {
  DispatchMappedActions,
  OverlayAction,
  OverlayContext,
  overlayActionHandlers
} from "./OverlayContext"
import { OverlayReducerState } from "./types"

export function useOverlayActions() {
  const { dispatch } = useContext(OverlayContext)
  return useMemo(
    () =>
      Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- `value` is only referenced through `typeof`, which typescript-eslint 8 counts as unused
        Object.entries(overlayActionHandlers).map(([key, value]) => [
          key,
          (action: Parameters<typeof value>[1]) => {
            dispatch({
              payload: action,
              type: key
            } as OverlayAction)
          }
        ])
      ) as unknown as DispatchMappedActions<
        OverlayReducerState,
        typeof overlayActionHandlers
      >,
    []
  )
}
